export default class Arr {
    static wrap(item) {
        if (item === undefined) {
            return [];
        }

        if (Array.isArray(item)) {
            return item;
        }

        return [item];
    }
}
